import React,{useEffect,useRef} from 'react';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {mapBounds,type MapCanvasProps} from './discoverMapGeometry';
const browser=globalThis as unknown as {
  document:{createElement:(tag:string)=>HTMLElement&{textContent:string|null}};
  ResizeObserver:new(callback:()=>void)=>{observe:(element:HTMLElement)=>void;disconnect:()=>void};
};

export default function DiscoverMapCanvas({points,selected,fit,onSelect,onFailure,label}:MapCanvasProps){
  const host=useRef<HTMLDivElement>(null),map=useRef<L.Map|null>(null),markers=useRef<L.LayerGroup|null>(null);
  const lastFit=useRef<number|null>(null),callbacks=useRef({onSelect,onFailure});callbacks.current={onSelect,onFailure};
  useEffect(()=>{
    if(!host.current)return;
    const instance=L.map(host.current,{attributionControl:true,zoomControl:true,scrollWheelZoom:false,
      zoomAnimation:false,fadeAnimation:false,markerZoomAnimation:false});
    map.current=instance;markers.current=L.layerGroup().addTo(instance);
    const tiles=L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{
      maxZoom:19,noWrap:true,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(instance);
    tiles.on('tileerror',()=>callbacks.current.onFailure());
    const resize=new browser.ResizeObserver(()=>instance.invalidateSize());resize.observe(host.current);
    return()=>{resize.disconnect();instance.stop();instance.remove();map.current=null;markers.current=null;lastFit.current=null;};
  },[]);
  useEffect(()=>{
    const instance=map.current,layer=markers.current;if(!instance||!layer)return;
    layer.clearLayers();
    for(const p of points){
      const title=browser.document.createElement('span');title.textContent=p.name??'';
      L.circleMarker([p.latitude,p.longitude],{radius:p.id===selected?12:9,
        color:'#ffffff',weight:2,fillColor:p.id===selected?'#be123c':'#2563eb',fillOpacity:1})
        .bindTooltip(title).on('click',()=>callbacks.current.onSelect(p.id)).addTo(layer);
    }
    if(lastFit.current!==fit){lastFit.current=fit;instance.fitBounds(mapBounds(points),{padding:[28,28],maxZoom:14,animate:false});}
  },[points,selected,fit]);
  useEffect(()=>{const p=points.find(item=>item.id===selected);if(p)map.current?.setView([p.latitude,p.longitude],14,{animate:false});},[selected,points]);
  return <div ref={host} role="region" aria-label={label} data-testid="discover-map-canvas"
    style={{height:'100%',minHeight:220,width:'100%',position:'relative',zIndex:0}}/>;
}
